"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.KHInputProviderKeyboard = void 0;
const KHInputKey_1 = require("./KHInputKey");
const KHInputProvider_1 = require("./KHInputProvider");
const KHUnifiedInput_1 = require("./KHUnifiedInput");
class KHInputKeyKeyboard extends KHInputKey_1.KHInputKey {
    constructor(key, inputProvider) {
        super();
        this.key = key;
        this.inputProvider = inputProvider;
    }
    updateFromKey() {
        const down = this.key.isDown;
        if (down) {
            KHUnifiedInput_1.KHUnifiedInput.lastInputSource = this.inputProvider;
        }
        this.update(this.key.isDown);
    }
}
class KHInputProviderKeyboard extends KHInputProvider_1.KHInputProvider {
    constructor(scene) {
        super();
        this.scene = scene;
        this.keys = new Map();
    }
    update(now, delta) {
        this.keys.forEach((value, key) => {
            value.updateFromKey();
        });
    }
    getInput(input /* Should be Phaser.Input.Keyboard.KeyCodes but TS gets mad if I do that */) {
        if (!this.keys.has(input)) {
            const phaserKey = this.scene.input.keyboard.addKey(input);
            const inputKey = new KHInputKeyKeyboard(phaserKey, this);
            const justDown = Phaser.Input.Keyboard.JustDown(phaserKey);
            const down = phaserKey.isDown;
            // Populate key isDown.
            if (down) {
                inputKey.update(down);
            }
            // Clear out justDown if it isn't just down.
            if (!justDown) {
                inputKey.update(down);
            }
            this.keys.set(input, inputKey);
        }
        const value = this.keys.get(input);
        return value;
    }
    isDown(input /* Should be Phaser.Input.Keyboard.KeyCodes but TS gets mad if I do that */) {
        return this.getInput(input).isDown();
    }
    isJustDown(input /* Should be Phaser.Input.Keyboard.KeyCodes but TS gets mad if I do that */) {
        return this.getInput(input).isJustDown();
    }
    type() {
        return KHInputProviderKeyboard.INPUT_TYPE;
    }
}
exports.KHInputProviderKeyboard = KHInputProviderKeyboard;
KHInputProviderKeyboard.INPUT_TYPE = "keyboard";
